"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.options = void 0;
var optionalProps_1 = require("./optionalProps");
Object.defineProperty(exports, "options", { enumerable: true, get: function () { return optionalProps_1.options; } });
